function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../../foundations/colors.module.scss";
import typography from "../../../foundations/typography.module.scss";
import { menuStyles } from "../../Menu/Menu.styles";
const baseFont = {
  fontFamily: typography.fontFamilyLight,
  color: colors.dark700,
  fontSize: typography.fontSizeP1
};
const signatureFont = {
  fontFamily: 'AlexBrush-Regular',
  fontWeight: 400,
  fontSize: '30px'
};
const defaultBorderColor = colors.dark900;
const hoverColor = colors.dark900;
const focusedColor = colors.purple800;
const errorColor = colors.red950;
const warningColor = colors.orange900;
const successColor = colors.green900;
const disabledColor = {
  text: colors.dark500,
  border: colors.dark300
};
const placeholderColor = colors.dark400;
export const useBaseTextFieldStyles = makeStyles({
  root: {
    width: props => props.width || (props.helperTextReserveSpace ? 'min-content' : '100%'),
    minWidth: props => props.minWidth || 0,
    '& .MuiSelect-select': {
      backgroundColor: 'transparent'
    }
  },
  inputRoot: _ref => {
    let {
      disableSuffixPadding,
      helperTextReserveSpace,
      width
    } = _ref;
    return _objectSpread(_objectSpread(_objectSpread({}, baseFont), {}, {
      backgroundColor: colors.dark50
    }, helperTextReserveSpace ? {
      width: width || 'fit-content'
    } : {}), {}, {
      // Disable input type=number arrows in Chrome, Safari, Edge, Opera
      '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      // Disable input type=number arrows in Firefox
      '& input[type=number]': {
        '-moz-appearance': 'textfield'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: defaultBorderColor,
        borderRadius: 4,
        '& span': {
          fontFamily: typography.fontFamilyLight
        }
      },
      '& .MuiOutlinedInput-inputAdornedStart': {
        paddingLeft: 8
      },
      '& .MuiOutlinedInput-inputAdornedEnd': {
        paddingRight: 8
      },
      '&.MuiOutlinedInput-adornedEnd': {
        paddingRight: disableSuffixPadding ? 0 : 14
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: hoverColor,
        borderWidth: 2
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: focusedColor
        },
        '& .MuiOutlinedInput-input': {
          caretColor: focusedColor
        }
      },
      '&.Mui-disabled': {
        color: disabledColor.text,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: disabledColor.border
        },
        '& .MuiOutlinedInput-input': {
          color: disabledColor.text,
          '&::placeholder': _objectSpread(_objectSpread({}, baseFont), {}, {
            opacity: 0.5
          })
        }
      },
      '&.Mui-error.MuiOutlinedInput-root': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: errorColor
        },
        '& .MuiOutlinedInput-input': {
          caretColor: errorColor
        }
      },
      '&.MuiOutlinedInput-multiline': {
        minHeight: '46px',
        padding: '8px 0'
      }
    });
  },
  inputInput: _ref2 => {
    let {
      isSignature,
      textColor
    } = _ref2;
    return _objectSpread(_objectSpread(_objectSpread({}, isSignature ? signatureFont : baseFont), textColor ? {
      color: textColor
    } : {}), {}, {
      padding: '4px 16px',
      lineHeight: '24px',
      '&::placeholder': _objectSpread(_objectSpread({}, isSignature ? signatureFont : baseFont), {}, {
        opacity: 0.5
      }),
      '&:-webkit-autofill': _objectSpread(_objectSpread({}, baseFont), textColor ? {
        color: textColor
      } : {}),
      '&:autofill': _objectSpread(_objectSpread({}, baseFont), textColor ? {
        color: textColor
      } : {})
    });
  },
  inputInput_medium: {
    height: 38,
    '&.MuiSelect-select': {
      lineHeight: '38px'
    }
  },
  inputInput_small: {
    height: 32,
    '&.MuiSelect-select': {
      lineHeight: '32px'
    }
  },
  label: _objectSpread(_objectSpread({}, baseFont), {}, {
    '&.Mui-disabled': {
      color: disabledColor.text
    },
    '&.Mui-focused': {
      color: focusedColor
    },
    '&.Mui-error': {
      color: baseFont.color,
      '&.MuiInputLabel-shrink': {
        color: errorColor
      },
      '& .sg-tf-asterix': {
        color: errorColor
      }
    }
  }),
  label_medium: {
    transform: 'translate(16px, 16px) scale(1)'
  },
  label_small: {
    transform: 'translate(16px, 13px) scale(1)'
  },
  ellipsis: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  helperText: _objectSpread(_objectSpread({}, baseFont), {}, {
    fontSize: 12,
    marginTop: 0,
    marginLeft: 0,
    '&.positionFixed': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      transform: 'translateY(100%)'
    },
    lineHeight: 'normal',
    '&.Mui-disabled': {
      color: disabledColor.text
    },
    '&.Mui-error': {
      color: errorColor
    }
  }),
  helperTextCollapse: {
    padding: '0 4px',
    marginTop: '4px !important',
    marginLeft: '0 !important',
    marginRight: '0 !important',
    marginBottom: '0 !important',
    width: '100%',
    boxSizing: 'border-box',
    maxWidth: '100%'
  },
  collapseWrapper: {
    width: '100%',
    marginTop: 0,
    '& > div': {
      width: '100%',
      marginTop: '0 !important'
    }
  },
  success: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: "".concat(successColor, " !important")
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: successColor
    },
    '& .sg-tf-asterix': {
      color: successColor
    }
  },
  warning: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: "".concat(warningColor, " !important")
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: warningColor
    },
    '& .sg-tf-asterix': {
      color: warningColor
    }
  },
  menu: _objectSpread({
    maxHeight: props => props.menuMaxHeight
  }, menuStyles),
  noOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  },
  selectPlaceholder: {
    color: placeholderColor
  },
  wrapper: props => ({
    display: 'flex',
    flexDirection: 'column',
    width: props.width || (props.helperTextReserveSpace ? 'min-content' : '100%'),
    minWidth: props.minWidth || 0
  })
});